export default __webpack_public_path__ + "static/media/RobotoMono-SemiBold.9d6dadd4.woff";